import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from 'src/app/shared/components/components.module';
import { OrderConfirmationComponent } from './order-confirmation.component';

@NgModule({
  imports: [CommonModule, ComponentsModule],
  declarations: [OrderConfirmationComponent]
})
export class OrderConfirmationModule {}
